<template>
  <div class="container">
    <div v-if="this.section" class="panel">

      <div class="panel-header">
        <div class="panel-title h4">

          <span v-if="section.display">{{section.pretty_name}}</span>
          <span v-else class="text-gray">{{section.pretty_name}}</span>

          <div class="columns float-right">
            <div class="column col-6">
              <div class="form-group">
                <label class="form-switch" style="bottom:10px;">
                  <input type="checkbox" v-model="section.display">
                  <i class="form-icon"></i>
                </label>
              </div>
            </div>
            <div class="column col-6">
              <button @click="hidden = !hidden" class="btn btn-sm float-right">
                <i class="icon" :class="{'icon-arrow-down': hidden, 'icon-arrow-up': !hidden}"></i>
              </button>
            </div>
          </div>
          
        </div>
      </div>

      <div v-show="!hidden" class="panel-body">
        <form class="form-horizontal">

          <div v-for="(f, i) in section.fields" class="form-group">
            <div class="col-3 col-sm-12">
              <label class="form-label">{{f.name}}</label>
            </div>
            <div class="col-9 col-sm-12">
              <input v-model="f.text" class="form-input input-sm" type="text">
            </div>
          </div>
        </form>

        <!-- <docMakerSection v-for="(s, i) in section.sections" v-bind:key="i" :section="s"></docMakerSection> -->

      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'docMakerSection',
  props: {
    section: Object
  },
  data () {
    return {
      hidden: !this.section.display
    }
  }
}
</script>



// WEBPACK FOOTER //
// docMakerSection.vue?1f32ae7b